import request from './request'

/**
 * 创建文章
 * @param {Object} params 创建文章请求参数
 * @param {string} params.title 文章标题
 * @param {string} params.content 文章内容描述
 * @param {string[]} [params.images] 图片列表
 * @param {string} [params.contactName] 联系人姓名
 * @param {string} [params.contactPhone] 联系电话
 * @param {string} [params.contactEmail] 联系邮箱
 * @returns {Promise} 返回文章ID
 */
export function createArticle(params) {
  if (!params || typeof params !== 'object') {
    return Promise.reject(new Error('请提供有效的文章参数'))
  }
  if (!params.title || typeof params.title !== 'string') {
    return Promise.reject(new Error('文章标题不能为空'))
  }
  if (!params.content || typeof params.content !== 'string') {
    return Promise.reject(new Error('文章内容不能为空'))
  }
  
  return request.post('/api/admin/article/create', params)
}

/**
 * 获取文章详情
 * @param {string} id 文章ID
 * @returns {Promise} 返回文章详情
 */
export function getArticleDetail(id) {
  if (!id || typeof id !== 'string') {
    return Promise.reject(new Error('文章ID不能为空'))
  }
  
  return request.get(`/api/admin/article/detail/${id}`)
}

/**
 * 更新文章
 * @param {Object} params 更新文章请求参数
 * @param {string} params.id 文章ID
 * @param {string} [params.title] 文章标题
 * @param {string} [params.content] 文章内容描述
 * @param {string[]} [params.images] 图片列表
 * @param {string} [params.contactName] 联系人姓名
 * @param {string} [params.contactPhone] 联系电话
 * @param {string} [params.contactEmail] 联系邮箱
 * @returns {Promise}
 */
export function updateArticle(params) {
  if (!params || typeof params !== 'object') {
    return Promise.reject(new Error('请提供有效的更新参数'))
  }
  if (!params.id || typeof params.id !== 'string') {
    return Promise.reject(new Error('文章ID不能为空'))
  }
  
  return request.put('/api/admin/article/update', params)
}

/**
 * 删除文章
 * @param {string} id 文章ID
 * @returns {Promise}
 */
export function deleteArticle(id) {
  if (!id || typeof id !== 'string') {
    return Promise.reject(new Error('文章ID不能为空'))
  }
  
  return request.delete(`/api/admin/article/delete/${id}`)
}

/**
 * 批量删除文章
 * @param {string[]} ids 文章ID数组
 * @returns {Promise}
 */
export function batchDeleteArticles(ids) {
  if (!Array.isArray(ids) || ids.length === 0) {
    return Promise.reject(new Error('请选择至少一篇文章进行删除'))
  }
  
  return request.delete('/api/admin/article/batch-delete', {
    data: ids
  })
}

/**
 * 上架文章
 * @param {string} id 文章ID
 * @returns {Promise}
 */
export function onlineArticle(id) {
  if (!id || typeof id !== 'string') {
    return Promise.reject(new Error('文章ID不能为空'))
  }
  
  return request.put(`/api/admin/article/online/${id}`)
}

/**
 * 下架文章
 * @param {string} id 文章ID
 * @returns {Promise}
 */
export function offlineArticle(id) {
  if (!id || typeof id !== 'string') {
    return Promise.reject(new Error('文章ID不能为空'))
  }
  
  return request.put(`/api/admin/article/offline/${id}`)
}

/**
 * 分页查询文章列表
 * @param {Object} [params] 查询参数
 * @param {number} [params.pageNum] 页码
 * @param {number} [params.pageSize] 每页数量
 * @param {string} [params.startTime] 开始时间
 * @param {string} [params.endTime] 结束时间
 * @param {Array} [params.sortItemList] 排序项列表
 * @param {boolean} [params.sortItemList[].isAsc] 是否升序
 * @param {string} [params.sortItemList[].column] 排序列
 * @param {string} [params.title] 文章标题（模糊查询）
 * @param {number} [params.auditStatus] 审核状态：0-审核失败 10-审核成功
 * @param {boolean} [params.validation] 上下架状态：0-下架 1-上架
 * @param {number} [params.size] 每页数量
 * @param {number} [params.current] 当前页码
 * @returns {Promise} 返回分页文章列表
 */
export function getArticleList(params = {}) {
  return request.post('/api/admin/article/page', params)
}

